import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ActiveSubscriptionsSelector from 'selectors/ActiveSubscriptionsSelector';

import { previewProration } from 'actions/stripeProrationActions';
import { fetchStripeCustomer } from 'actions/stripeCustomerActions';
import {
  upgradeMembership,
  createMembership,
} from 'actions/stripeSubscriptionActions';
import { resumeMembership } from 'actions/userActions';

import Loading from 'components/Loading/Loading';
import ModalButton from 'components/modals/ModalButton/ModalButton';
import UpdatePlan from 'components/PlanSelect/UpdatePlan';
import MonthlyCommitment from 'components/PlanSelect/MonthlyCommitment';
import DisabledMonthlyCommitment from 'components/PlanSelect/DisabledMonthlyCommitment';
import AnnualCommitment from 'components/PlanSelect/AnnualCommitment';

import { BILLING_CYCLE, PLAN_CATEGORY } from 'config/constants';

import {
  getCommitmentGroup, getEquivalentPlan, getPriceSubText, isPlanCurrentlyOfferedAndAnnual
} from 'utils/stripePlanUtils';

import CartSummary from './CartSummary';
import CurrentStatus from './CurrentStatus';

import './style.css';

class LowerTierPlan extends Component {
  constructor(props) {
    super(props);
    this.priceSubText = getPriceSubText('update');
    this.state = {
      subscriptionId: null,
      selectedPlan: null,
      currentPlan: null,
      isUpdatingPlan: false,
      errorMessage: null,
    };
  }

  componentDidMount() {
    if (_.isEmpty(this.props.stripeCustomer)) {
      this.props.fetchStripeCustomer(this.props.user.profile.stripeCustomerId);
    } else {
      this.loadStripeSubscription(this.props.activeStripeSubscriptions);
    }
  }

  // TODO: Not totally sure this component makes sense
  // Will a user ever change without this component being completely reloaded?
  // Is the stripeSubscription.status 'loading' a good thing to check?
  // It appears to work for now and is way less convoluted so this is a step
  // in the right direction
  componentWillReceiveProps(nextProps) {
    // do nothing if the new props doesn't have a customer.id
    // or if the id is unchanged from the previous props
    if (
      nextProps.user.profile.id &&
      nextProps.user.profile.id !== this.props.user.profile.id
    ) {
      this.props.fetchStripeCustomer(nextProps.user.profile.stripeCustomerId);
    }

    if (nextProps.stripeSubscription.status !== 'loading') {
      this.loadStripeSubscription(nextProps.activeStripeSubscriptions);
    }
  }

  loadStripeSubscription = (activeStripeSubscription) => {
    if (_.isEmpty(activeStripeSubscription.data)) return;

    const stripeSubscription = activeStripeSubscription.data;

    const currentPlan = this.props.user.profile.stripePlan;
    currentPlan.id = stripeSubscription.stripePlanId;
    const newState = {
      currentPlan,
      subscriptionId: stripeSubscription.stripeSubscriptionId,
      subscriptionItemId: stripeSubscription.stripeSubscriptionItemId,
    };
    if (currentPlan.currentlyOffered) newState.selectedPlan = currentPlan;
    this.setState(newState);
  };

  handleSelectCycle = (selectedPlan) => {
    this.setState({ selectedPlan }, this.handleChangePlan);
  };

  handleChangePlan = () => {
    const { subscriptionId, selectedPlan, currentPlan } = this.state;

    if (!currentPlan || !selectedPlan) {
      return;
    }

    if (currentPlan.id !== selectedPlan.id) {
      this.props.previewProration(subscriptionId, selectedPlan.id);
    }
  };

  handleUpdatePlan = () => {
    this.setState({ errorMessage: null });
    const { subscriptionId, subscriptionItemId, selectedPlan } = this.state;
    const { stripeCustomerId } = this.props.user.profile;

    if (selectedPlan && stripeCustomerId) {
      const trialFromPlan = selectedPlan.cycle === BILLING_CYCLE.MONTHLY;

      if (subscriptionId == null) {
        this.setState({ isUpdatingPlan: true });
        const data = {
          stripeCustomerId,
          planId: selectedPlan.id,
          category: PLAN_CATEGORY.LANGUAGE,
          nt: 1,
        };
        this.props.createMembership(
          data,
          () => {
            this.setState({ isUpdatingPlan: false });
            this.props.fetchStripeCustomer(
              this.props.user.profile.stripeCustomerId
            );
          },
          (response) => {
            this.setState({
              isUpdatingPlan: false,
              errorMessage: response.message || 'Unexpected error',
            });
          }
        );
      } else {
        this.setState({ isUpdatingPlan: true });
        this.props.upgradeMembership(
          subscriptionId,
          subscriptionItemId,
          selectedPlan.id,
          trialFromPlan,
          () => {
            this.setState({ isUpdatingPlan: false });
            this.props.fetchStripeCustomer(
              this.props.user.profile.stripeCustomerId
            );
          },
          (response) => {
            this.setState({
              errorMessage: response.message || 'Unexpected error',
            });
          }
        );
      }
    }
  };

  handleReactivateMembership = () => {
    const { stripeCustomerId } = this.props.user.profile;
    this.props.resumeMembership(stripeCustomerId);
  };

  renderLoading() {
    return (
      <div className="LowerTierPlan">
        <Loading />
      </div>
    );
  }

  render() {
    const { activeStripeSubscriptions, stripeSubscription } = this.props;
    if (activeStripeSubscriptions.status === 'loading') {
      return this.renderLoading();
    }

    const paused = this.props.user.profile.pause;

    const { currentPlan, selectedPlan } = this.state;
    let upgradeMembershipButton = null;
    const isUserDisabledForPlanTransition = isPlanCurrentlyOfferedAndAnnual(this.props.user.profile.stripePlan);
    const initialPlan = selectedPlan || currentPlan || this.props.user.profile.stripePlan;
    // initialPlan could be null, availablePlan cannot be null
    // `availablePlan` is an instance of currently offered plan
    const availablePlan = getEquivalentPlan(initialPlan);
    const commitmentGroup = getCommitmentGroup(availablePlan);
    const annualCommitmentPlan = commitmentGroup.find(cGroup => cGroup.isAnnual);
    const monthlyCommitmentPlan = commitmentGroup.find(cGroup => !cGroup.isAnnual);
    if (currentPlan && !currentPlan.isPrepaid) {
      if (stripeSubscription.status === 'loading') {
        upgradeMembershipButton = <Loading size="small" />;
      } else {
        upgradeMembershipButton = paused ? (
          <button
            type="button"
            className="btn btn-primary btn-cursor mt-4"
            onClick={this.handleReactivateMembership}
          >
            Reactivate membership
          </button>
        ) : (
          <ModalButton
            className="btn btn-primary btn-cursor btn-gray mt-4"
            modalId="pause-membership-modal"
          >
            Pause membership
          </ModalButton>
        );
      }
    }

    return (
      <div className="LowerTierPlan p-3 p-md-0">
        <div className="row">
          <div className="col-md-12 col-lg-8 mb-3 mb-lg-0">
            {this.state.errorMessage && (
              <p className="text-danger mt-2">{this.state.errorMessage}</p>
            )}

            <CurrentStatus />

            <div className="card">
              <div className="card-block pt-5 px-5 pb-4 fit-small">
                <UpdatePlan
                  commitmentGroup={commitmentGroup}
                  stripePlan={this.props.user.profile.stripePlan}
                  selectedPlan={availablePlan}
                  onPlanSelect={this.handleSelectCycle}
                  trialStatus={this.props.user.profile.trialStatus}
                >
                  <AnnualCommitment
                    priceSubText={this.priceSubText}
                    availablePlan={availablePlan}
                    annualPlan={annualCommitmentPlan}
                    onPlanSelect={this.handleSelectCycle}
                  />
                  {
                    isUserDisabledForPlanTransition ?
                      <DisabledMonthlyCommitment monthlyPlan={monthlyCommitmentPlan} /> :
                      (
                        <MonthlyCommitment
                          availablePlan={availablePlan}
                          monthlyPlan={monthlyCommitmentPlan}
                          onPlanSelect={this.handleSelectCycle}
                        />
                      )
                  }
                </UpdatePlan>
              </div>
            </div>
          </div>

          <div className="col-md-12 col-lg-4 pl-lg-0">
            <CartSummary
              currentPlan={currentPlan}
              selectedPlan={selectedPlan}
              onUpdate={this.handleUpdatePlan}
              isUpdatingPlan={this.state.isUpdatingPlan}
            />
          </div>
        </div>

        {upgradeMembershipButton}

        {currentPlan && (
          <ModalButton
            className="btn btn-cancel d-inline-block mt-4"
            to="#"
            type="link"
            modalId="before-delete-ms-modal"
          >
            Cancel my membership
          </ModalButton>
        )}
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    stripeCustomer: state.stripeCustomer,
    stripeSubscription: state.stripeSubscription,
    activeStripeSubscriptions: ActiveSubscriptionsSelector(state),
  };
}

export default connect(mapStateToProps, {
  fetchStripeCustomer,
  upgradeMembership,
  createMembership,
  resumeMembership,
  previewProration,
})(LowerTierPlan);



// WEBPACK FOOTER //
// ./src/pages/student/Profile/routes/LowerTierPlan/index.js